import { useDispatch, useSelector } from 'react-redux';
import { selectIsLoanInProgress, selectLoan } from '@store/selectors/widgets.selectors';
import isEmpty from 'lodash/isEmpty';
import { Identifier } from '@types';
import { useQuery } from '@tanstack/react-query';
import { axiosApi } from '@utils/fetch';
import { AxiosRequestConfig } from 'axios';
import { config } from '../../../config';
import React from 'react';
import { LoanInProgressWrapper, StackBase } from '@fmc-digital/ui';
import { set } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { setSelectedLoanNumber } from '@store/actions/widgets.actions';
import { useTheme } from '@mui/material';
import { logUserEvent } from '@analytics/amplifyLogging';

const getLoanInProgressTemplate = async (config: AxiosRequestConfig) => {
    return axiosApi(config);
};
const RenderLIPTile = ({ origination }: { origination: Identifier }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const allLoans = useSelector(selectLoan);

    const { data, isLoading } = useQuery({
        queryKey: ['new-loan', origination],
        queryFn: () =>
            getLoanInProgressTemplate({
                url: `${config.env('selfServUrl')}/${origination.identifier}/status-tile`,
                method: 'get',
                headers: {
                    applicationName: 'auth_customer_portal',
                    'x-api-key': `${config.env('xApiKey')}`
                }
            }),
        select: ({ response }) => response
    });

    const onViewLIPClicked = () => {
        const selectedLoan = allLoans.find(loan => loan.identifier === origination.identifier);
        navigate(`/new-loan/${origination.identifier}`);
        dispatch(setSelectedLoanNumber(selectedLoan));

        logUserEvent({
            action: 'LoanInProgressClicked',
            type: 'DashboardLIPTile',
            description: `Dashboard LIP Tile`,
            loanNumber: selectedLoan.identifier
        });
    };

    if (isLoading) return null;
    return <LoanInProgressWrapper {...data} onViewLIPClicked={onViewLIPClicked} />;
};
export const NewLoanInProgressTiles = () => {
    const theme = useTheme();
    const originations: Identifier[] | undefined = useSelector(selectIsLoanInProgress);

    if (isEmpty(originations)) return null;

    return (
        <StackBase gap={{ xs: theme.spacing(2), md: theme.spacing(4) }}>
            {originations.map((origination: Identifier) => (
                <RenderLIPTile origination={origination} key={origination.identifier} />
            ))}
        </StackBase>
    );
};
